/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorFormula'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PerformanceIndicatorFormula'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorFormula);
  }
}(this, function(ApiClient, PerformanceIndicatorFormula) {
  'use strict';




  /**
   * The PerformanceIndicatorReport model module.
   * @module model/PerformanceIndicatorReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorReport</code>.
   * @alias module:model/PerformanceIndicatorReport
   * @class
   */
  var exports = function() {
    var _this = this;











































  };

  /**
   * Constructs a <code>PerformanceIndicatorReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorReport} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorReport} The populated <code>PerformanceIndicatorReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('HasAnyData')) {
        obj['HasAnyData'] = ApiClient.convertToType(data['HasAnyData'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevels')) {
        obj['TrackingLevels'] = ApiClient.convertToType(data['TrackingLevels'], ['Integer']);
      }
      if (data.hasOwnProperty('Dimensions')) {
        obj['Dimensions'] = ApiClient.convertToType(data['Dimensions'], ['Integer']);
      }
      if (data.hasOwnProperty('Uses')) {
        obj['Uses'] = ApiClient.convertToType(data['Uses'], ['Integer']);
      }
      if (data.hasOwnProperty('UsedIn')) {
        obj['UsedIn'] = ApiClient.convertToType(data['UsedIn'], ['Integer']);
      }
      if (data.hasOwnProperty('Formula')) {
        obj['Formula'] = ApiClient.convertToType(data['Formula'], [PerformanceIndicatorFormula]);
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('SystemTypeID')) {
        obj['SystemTypeID'] = ApiClient.convertToType(data['SystemTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PerformancePerspectiveGroupID')) {
        obj['PerformancePerspectiveGroupID'] = ApiClient.convertToType(data['PerformancePerspectiveGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FinancialFormula')) {
        obj['FinancialFormula'] = ApiClient.convertToType(data['FinancialFormula'], 'String');
      }
      if (data.hasOwnProperty('ValueDependencyRuleID')) {
        obj['ValueDependencyRuleID'] = ApiClient.convertToType(data['ValueDependencyRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('CollectProduct')) {
        obj['CollectProduct'] = ApiClient.convertToType(data['CollectProduct'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectGeoArea')) {
        obj['CollectGeoArea'] = ApiClient.convertToType(data['CollectGeoArea'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectCustomer')) {
        obj['CollectCustomer'] = ApiClient.convertToType(data['CollectCustomer'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectTrackingLevel1')) {
        obj['CollectTrackingLevel1'] = ApiClient.convertToType(data['CollectTrackingLevel1'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectTrackingLevel2')) {
        obj['CollectTrackingLevel2'] = ApiClient.convertToType(data['CollectTrackingLevel2'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectTrackingLevel3')) {
        obj['CollectTrackingLevel3'] = ApiClient.convertToType(data['CollectTrackingLevel3'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectTrackingLevel4')) {
        obj['CollectTrackingLevel4'] = ApiClient.convertToType(data['CollectTrackingLevel4'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectLegalUnit')) {
        obj['CollectLegalUnit'] = ApiClient.convertToType(data['CollectLegalUnit'], 'Boolean');
      }
      if (data.hasOwnProperty('CollectFunction')) {
        obj['CollectFunction'] = ApiClient.convertToType(data['CollectFunction'], 'Boolean');
      }
      if (data.hasOwnProperty('DimensionBudget')) {
        obj['DimensionBudget'] = ApiClient.convertToType(data['DimensionBudget'], 'Boolean');
      }
      if (data.hasOwnProperty('DimensionForecast')) {
        obj['DimensionForecast'] = ApiClient.convertToType(data['DimensionForecast'], 'Boolean');
      }
      if (data.hasOwnProperty('DimensionGoal')) {
        obj['DimensionGoal'] = ApiClient.convertToType(data['DimensionGoal'], 'Boolean');
      }
      if (data.hasOwnProperty('DefaultPeriodTypeID')) {
        obj['DefaultPeriodTypeID'] = ApiClient.convertToType(data['DefaultPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Depth')) {
        obj['Depth'] = ApiClient.convertToType(data['Depth'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('FinancialParentID')) {
        obj['FinancialParentID'] = ApiClient.convertToType(data['FinancialParentID'], 'Integer');
      }
      if (data.hasOwnProperty('NegateFinancialValue')) {
        obj['NegateFinancialValue'] = ApiClient.convertToType(data['NegateFinancialValue'], 'Boolean');
      }
      if (data.hasOwnProperty('SupportDrilling')) {
        obj['SupportDrilling'] = ApiClient.convertToType(data['SupportDrilling'], 'Boolean');
      }
      if (data.hasOwnProperty('IsFinancial')) {
        obj['IsFinancial'] = ApiClient.convertToType(data['IsFinancial'], 'Boolean');
      }
      if (data.hasOwnProperty('ValueSuffix')) {
        obj['ValueSuffix'] = ApiClient.convertToType(data['ValueSuffix'], 'String');
      }
      if (data.hasOwnProperty('MostDetailedPeriodTypeID')) {
        obj['MostDetailedPeriodTypeID'] = ApiClient.convertToType(data['MostDetailedPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ShowInIndicatorMap')) {
        obj['ShowInIndicatorMap'] = ApiClient.convertToType(data['ShowInIndicatorMap'], 'Boolean');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('FilteredIndicatorFormulaDynamicFilter')) {
        obj['FilteredIndicatorFormulaDynamicFilter'] = ApiClient.convertToType(data['FilteredIndicatorFormulaDynamicFilter'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Boolean} HasAnyData
   * @default false
   */
  exports.prototype['HasAnyData'] = false;
  /**
   * @member {Array.<Integer>} TrackingLevels
   */
  exports.prototype['TrackingLevels'] = undefined;
  /**
   * @member {Array.<Integer>} Dimensions
   */
  exports.prototype['Dimensions'] = undefined;
  /**
   * @member {Array.<Integer>} Uses
   */
  exports.prototype['Uses'] = undefined;
  /**
   * @member {Array.<Integer>} UsedIn
   */
  exports.prototype['UsedIn'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceIndicatorFormula>} Formula
   */
  exports.prototype['Formula'] = undefined;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Integer} SystemTypeID
   * @default 0
   */
  exports.prototype['SystemTypeID'] = 0;
  /**
   * @member {Integer} PerformancePerspectiveGroupID
   * @default 0
   */
  exports.prototype['PerformancePerspectiveGroupID'] = 0;
  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} FinancialFormula
   * @default ''
   */
  exports.prototype['FinancialFormula'] = '';
  /**
   * @member {Integer} ValueDependencyRuleID
   */
  exports.prototype['ValueDependencyRuleID'] = undefined;
  /**
   * @member {Boolean} CollectProduct
   * @default false
   */
  exports.prototype['CollectProduct'] = false;
  /**
   * @member {Boolean} CollectGeoArea
   * @default false
   */
  exports.prototype['CollectGeoArea'] = false;
  /**
   * @member {Boolean} CollectCustomer
   * @default false
   */
  exports.prototype['CollectCustomer'] = false;
  /**
   * @member {Boolean} CollectTrackingLevel1
   * @default false
   */
  exports.prototype['CollectTrackingLevel1'] = false;
  /**
   * @member {Boolean} CollectTrackingLevel2
   * @default false
   */
  exports.prototype['CollectTrackingLevel2'] = false;
  /**
   * @member {Boolean} CollectTrackingLevel3
   * @default false
   */
  exports.prototype['CollectTrackingLevel3'] = false;
  /**
   * @member {Boolean} CollectTrackingLevel4
   * @default false
   */
  exports.prototype['CollectTrackingLevel4'] = false;
  /**
   * @member {Boolean} CollectLegalUnit
   * @default false
   */
  exports.prototype['CollectLegalUnit'] = false;
  /**
   * @member {Boolean} CollectFunction
   * @default false
   */
  exports.prototype['CollectFunction'] = false;
  /**
   * @member {Boolean} DimensionBudget
   * @default false
   */
  exports.prototype['DimensionBudget'] = false;
  /**
   * @member {Boolean} DimensionForecast
   * @default false
   */
  exports.prototype['DimensionForecast'] = false;
  /**
   * @member {Boolean} DimensionGoal
   * @default false
   */
  exports.prototype['DimensionGoal'] = false;
  /**
   * @member {Integer} DefaultPeriodTypeID
   */
  exports.prototype['DefaultPeriodTypeID'] = undefined;
  /**
   * @member {Integer} Depth
   */
  exports.prototype['Depth'] = undefined;
  /**
   * @member {Integer} Sort
   */
  exports.prototype['Sort'] = undefined;
  /**
   * @member {Integer} FinancialParentID
   */
  exports.prototype['FinancialParentID'] = undefined;
  /**
   * @member {Boolean} NegateFinancialValue
   * @default false
   */
  exports.prototype['NegateFinancialValue'] = false;
  /**
   * @member {Boolean} SupportDrilling
   * @default false
   */
  exports.prototype['SupportDrilling'] = false;
  /**
   * @member {Boolean} IsFinancial
   * @default false
   */
  exports.prototype['IsFinancial'] = false;
  /**
   * @member {String} ValueSuffix
   * @default ''
   */
  exports.prototype['ValueSuffix'] = '';
  /**
   * @member {Integer} MostDetailedPeriodTypeID
   * @default 0
   */
  exports.prototype['MostDetailedPeriodTypeID'] = 0;
  /**
   * @member {Boolean} ShowInIndicatorMap
   * @default false
   */
  exports.prototype['ShowInIndicatorMap'] = false;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   */
  exports.prototype['CreatorID'] = undefined;
  /**
   * @member {Boolean} FilteredIndicatorFormulaDynamicFilter
   * @default false
   */
  exports.prototype['FilteredIndicatorFormulaDynamicFilter'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


